export enum SnsType {
  EMAIL = 'email',
}

// https://debankglobal.larksuite.com/docx/Nx17dfsBVokyKoxa4UNu6Kqps0e
export type PermissionLevelType =
  | 'feed_draw' // 10 * rank_factor
  | 'article' // 3 * rank_factor
  | 'feed_comment' // 10 * rank_factor
  | 'feed_post'
  | 'feed_poll'
  | 'chat' // 10 * rank_factor
  | 'article_trust' // 50 * rank_factor
  | 'article_distrust'; // 10 * rank_factor

export type PermissionLevel = {
  total_count: number;
  type: PermissionLevelType;
  used_count: number;
  wait_seconds: number;

  _usedCount: string;
  _totalCount: string;
};
